<template>
    <div class="py-4 container-fluid">      
        <div class="card-body">
            <div class="row">
                <div class="col-lg-12">
                    <div class="row mb-5">
                        <div class="col-lg-3">
                            <overview-missing-side-nav />
                        </div>
                        <div class="col-lg-9 mt-lg-0 mt-4">
                            <missing-overview />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row"></div>
        </div>
    </div>        
</template>
<script>
import OverviewMissingSideNav from "./components/OverviewMissingSideNav.vue"
import MissingOverview from "./components/MissingOverview.vue"

export default {
    name: 'AnimalMissing_overview_page',
    components: {
        OverviewMissingSideNav,
        MissingOverview
    },
    data() {
        return {
            Id: '',
            animal: [],
            gets: []
        }
    },
    async mounted() {        
    },
}
</script>